export default __webpack_public_path__ + "static/media/plus.5ef75916.svg";